/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateScreenerSettingRequest
 */
export interface UpdateScreenerSettingRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateScreenerSettingRequest
     */
    value?: string;
}

/**
 * Check if a given object implements the UpdateScreenerSettingRequest interface.
 */
export function instanceOfUpdateScreenerSettingRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateScreenerSettingRequestFromJSON(json: any): UpdateScreenerSettingRequest {
    return UpdateScreenerSettingRequestFromJSONTyped(json, false);
}

export function UpdateScreenerSettingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateScreenerSettingRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function UpdateScreenerSettingRequestToJSON(value?: UpdateScreenerSettingRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

